<template>
  <div>
    <v-btn
      class="hidden-sm-and-down"
      color="primary"
      rounded
      small
      @click="open()"
      >New Demo</v-btn
    >
    <v-btn
      class="hidden-sm-and-up primary"
      small
      icon
      color="primary"
      @click="open()"
    >
      <v-icon small color="white"> mdi-plus </v-icon>
    </v-btn>
    <v-navigation-drawer
      app
      temporary
      right
      disable-resize-watcher
      width="650px"
      v-model="show"
      class="actionDrawer"
    >
      <v-card flat>
        <v-card-text class="pt-0">
          <v-row class="mx-4 mt-4" justify="center" align="center">
            <v-col cols="2">
              <v-btn @click="cancelOperation()" color="primary" icon>
                <v-icon>mdi-arrow-left-bold-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="8" class="text-center">
              <v-img
                :src="this.$store.state.agency.agencyLogo"
                width="280px"
                class="mx-auto"
              />
            </v-col>
            <v-col cols="2"> </v-col>
          </v-row>
          <v-row class="mx-4">
            <v-col cols="12">
              <v-form ref="form" v-model="valid">
                <v-row>
                  <v-col cols="12" class="text-center">
                    <h2 class="compeatfont mb-2">New Demo Report</h2>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-text-field
                      v-model="firstName"
                      label="Client First Name"
                      :rules="textRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                    <v-text-field
                      v-model="lastName"
                      label="Client Last Name"
                      :rules="textRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-0">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="Client Email Address"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    class="py-0"
                    v-if="!this.$store.state.user.resellerUid"
                  >
                    <v-select
                      v-model="salesPerson"
                      :items="salesPeople"
                      label="Select Sales Person (Defaults to submitting user)"
                      item-text="name"
                      item-value="id"
                      class="selectpackage"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <h3 class="mb-0 compeatfont">Add Pages Below</h3>
                  </v-col>
                  <v-col class="col-12 py-0">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          type="text"
                          class="facebookHandleInput"
                          v-model="search"
                          :placeholder="dynamicLabel"
                          @keyup="searchForCompany()"
                          v-on="on"
                          v-bind="attrs"
                          :loading="loadingSearch"
                        />
                      </template>

                      <v-list class="listofpages">
                        <v-list-item v-if="this.search == '' && !loadingSearch">
                          <v-list-item-title>Type to search </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="this.searchPageError == true">
                          <v-list-item-title
                            >{{ searchErrorMessage }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="loadingSearch == true">
                          <v-list-item-title
                            >Please Wait, pages logging
                            <v-progress-circular indeterminate color="primary">
                            </v-progress-circular
                          ></v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="searchResult in searchResults"
                          :key="searchResult.id"
                          @click="selectCompany(searchResult)"
                        >
                          <v-avatar size="40" class="mr-2">
                            <v-img :src="searchResult.icon" />
                          </v-avatar>
                          <v-list-item-title>
                            {{ searchResult.name }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col v-if="packagePages != ''" cols="12">
                    <v-list>
                      <v-list-item
                        v-for="(packagePages, index) in packagePages"
                        :key="packagePages.id"
                        class="py-2"
                      >
                        <v-avatar size="40" class="mr-2">
                          <v-img :src="packagePages.icon" />
                        </v-avatar>
                        <v-list-item-content class="text-left">
                          <v-list-item-title>
                            {{ packagePages.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content v-if="index == 0">
                          <v-list-item-title>
                            - Primary page
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-btn @click="deletePage(index)" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
                <v-row class="actionsbuttons">
                  <v-col class="col-6 text-center">
                    <v-btn
                      small
                      rounded
                      @click="cancelOperation()"
                      class="secondary white--text"
                    >
                      Cancel
                    </v-btn>
                  </v-col>
                  <v-col class="col-6 text-center">
                    <v-btn
                      small
                      :disabled="!valid || packagePages.length < 2"
                      rounded
                      @click="createDemoReport()"
                      class="primary white--text"
                    >
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="120">
          <p class="mb-0 overlaytext">Please Wait...</p>
        </v-progress-circular>
      </v-overlay>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../firebaseConfig";
export default {
  props: ["successAlert", "salesPeople"],

  data: () => ({
    //overlay for loading
    overlay: false,
    //boolean to have nav bar show
    show: false,
    //form varibles and validation
    valid: false,
    textRules: [(v) => !!v || "Field is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    //search varible for company search
    search: "",
    loadingSearch: false,
    searchResults: [],
    searchPageError: false,
    searchErrorMessage: "",
    packagePages: [],

    //form data
    firstName: "",
    lastName: "",
    email: "",
    salesPerson: "",
  }),
  computed: {
    dynamicLabel() {
      if (this.packagePages.length !== 0) {
        return "Competitor pages";
      } else {
        // Provide a default label when packagePages.length is 0
        return "Client Facebook Page";
      }
    },
  },
  methods: {
    // seach for company pages
    searchForCompany() {
      this.searchPageError = false;

      if (this.search.length < 2) {
        this.searchResults = [];
        this.loadingSearch = false; // No need to show loading for short queries
        return;
      }

      if (this.loadingTimer) {
        clearTimeout(this.loadingTimer); // Clear the previous timeout
      }

      this.loadingTimer = setTimeout(() => {
        this.loadingSearch = true; // Show loading after a delay
      }, 300); // Adjust the delay time as needed

      const functions = getFunctions(firebaseApp, "europe-west2");
      const searchFacebookPage = httpsCallable(functions, "searchFacebookPage");

      const currentSearchQuery = this.search;

      searchFacebookPage({
        query: this.search,
        fbToken: this.$store.state.user.facebookToken,
      })
        .then((result) => {
          if (this.search === currentSearchQuery) {
            let searchpages = result.data.response.pageData;
            this.searchResults = [];
            this.searchResults.push(...searchpages);
            this.focus = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.searchPageError = true;
          this.searchErrorMessage = "Something went wrong please try again";
        })
        .finally(() => {
          clearTimeout(this.loadingTimer); // Clear the timeout
          this.loadingSearch = false;
        });
    },
    //add Company to array
    selectCompany(facebookpage) {
      this.packagePages.push(facebookpage);
      this.searchResults = [];
      this.search = "";
      this.focus = false;
    },
    // delete pages from packagePages array
    deletePage(index) {
      this.packagePages.splice(index, 1);
    },
    // Create Demo report
    createDemoReport() {
      this.overlay = true;
      const pageIds = this.packagePages.map((page) => page.id);

      let salesPersonForDemo = "";
      let salesPersonEmail = "";

      if (this.salesPerson == "") {
        salesPersonForDemo = this.$store.state.user.id;
        salesPersonEmail = this.$store.state.user.email;
      } else {
        salesPersonForDemo = this.salesPerson;

        this.salesPeople.forEach((item) => {
          if (item.id == salesPersonForDemo) {
            salesPersonEmail = item.email;
          }
        });
      }

      const functions = getFunctions(firebaseApp, "europe-west2");
      const generateCompetitiveAnalysisReport = httpsCallable(
        functions,
        "generateCompetitiveAnalysisReport"
      );

      generateCompetitiveAnalysisReport({
        pageIds: pageIds,
        agency: this.$store.state.agency,
        agencyUser: this.$store.state.user.id,
        salesPerson: salesPersonForDemo,
        salesPersonEmail: salesPersonEmail,
        reportType: "demo",
        prospectingClientName: this.firstName + " " + this.lastName,
        prospectingClientEmail: this.email,
        packagePages: this.packagePages,
      })
        .then((result) => {
          console.log("result", result);
          let alertType = "success";
          let successResponse = "Demo Report Created Successfully";
          this.show = false;
          this.overlay = false;
          this.packagePages = [];
          this.$refs.form.reset();
          this.$emit("successAlert", successResponse, alertType);
        })
        .catch((error) => {
          console.log(error);
          this.overlay = false;
        });
    },
    //Validates the fields
    validate() {
      this.$refs.form.validate();
    },
    //cancel error popup
    cancelError() {
      this.overlay = false;
    },
    //closes the side nav
    cancelOperation() {
      this.$refs.form.reset();
      this.show = false;
    },
    // this.firstName = "";
    //   this.lastName = "";
    //   this.email = "";
    //   this.salesPerson = "";
    //   this.packagePages = [];
    //   this.show = false;
    //opens and closes the side nav
    open() {
      this.show = !this.show;
    },
  },
};
</script>

<style>
h6 {
  font-size: 30px;
}
</style>
